<template>
    <div v-if="subVisible">
        <el-dialog :title="subDialogTitle" :close-on-click-modal="false" :visible.sync="subVisible" :before-close="dialogClose" width="550px">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="queryForm.evaluateTypeId" clearable placeholder="评价类型">
                        <el-option
                            v-for="item in evaluateTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="queryForm.performanceType"  placeholder="表现类型">
                        <el-option
                            v-for="item in performanceTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <el-button type="primary" icon="search" @click="getData()">查询</el-button>

            <div style="display: block; height:40px;float:right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="batchAdd">批量添加</el-button>
            </div>
            <el-table
                :data="data"
                row-key="id"
                height="300"
                border
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="name" label="指标标签"></el-table-column>
            </el-table>
            
        </el-dialog>
    </div>
</template>
       
<script>
import http from '../../../common/http';

export default {
    data() {
        return {
            subVisible: false,
            queryForm: {
                classId:'',
                performanceType: 1,
                evaluateTypeId: ''
            },
            common:{
                checkDataArr:[]
            },
            data:[],
            performanceTypes:[{
                value: 1,
                label: '表扬'
            },
            {
                value: 2,
                label: '待改进'  
            }],
            evaluateTypes:[],
            subDialogTitle:"",
            // studentData: undefined,

        }
    },
    created: function () {
    },
    computed: {
    },
    methods: {
        indexMethod(index) {
            return index+1;
        },
        init(data, classId) {
            console.log('标签库',data)
            this.subDialogTitle = data.name + "指标库"
            this.subVisible = true

            this.studentData = data
            this.queryForm.evaluateType = 1
            this.queryForm.evaluateTypeId=""
            this.queryForm.classId = classId
            this.data = []

            // 读指标数据
            this.getData()
        },
        handleSelectionChange(val){
            this.common.checkDataArr = []
            for (let i = 0;i < val.length;i++){
                this.common.checkDataArr.push(val[i].name)
            }
        },
        dialogClose(done) {
            done()
            this.$reload
        },
        //查询班级
        getData() {
            let url = this.evaluateDetailEvaluateTitleListUrl
            let data = { 
                evaluateType: this.queryForm.performanceType,
                evaluateTypeId: this.queryForm.evaluateTypeId,
                classId: this.queryForm.classId
            };
            this.apiPost(url, data).then((res) => {
                console.log('指标库', res);
                if (res.status == 200) {
                    this.data = res.data.evaluateIndexs
                    this.evaluateTypes = res.data.evaluateTypes
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log(err)
            });
        },
        // 批量添加
        batchAdd(){
            let dataArr = this.common.checkDataArr
            if(dataArr.length === 0){
                this.$commonFn.showTip("请选择数据",2)
                return
            } 

            // 数据指标标签过滤，相同不进行添加
            let indexDatas = new Array()
            let indexLabels = this.studentData.indexLabels
            if(indexLabels.length > 0){
                for(let j=0; j<dataArr.length;j++){
                    let isHaveExist = false
                    for(let i=0; i<indexLabels.length;i++){
                        if(indexLabels[i].name === dataArr[j]){
                            isHaveExist = true
                            break
                        }
                    }

                    if(!isHaveExist){
                        indexDatas.push(dataArr[j])
                    }
                }
            }else{
                indexDatas = dataArr
            }
 
            // 如果indexLabels为字符串类型，表示为空，需初始为数组
            if(typeof(this.studentData.indexLabels) == 'string'){
                this.studentData.indexLabels = []
            }
            for(let i=0; i<indexDatas.length; i++){
                let indexLabel ={
                    name:indexDatas[i],
                    type:"info"
                }
                this.studentData.indexLabels.push(indexLabel)
            }
            // 隐藏
            this.subVisible=false
        }
    },
    destroyed() {
    },
    mixins: [http]
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/IndexLabelSet.vue